import { Box, Stack, SxProps, Theme, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'
import { themeColor } from '../../layout/theme/color'
import { fadeSlideIn } from './animations'
import { cardSurfaceSx } from './styles'

interface CardProps {
  title?: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  /** No inner padding (content brings its own, e.g. a list). */
  flush?: boolean
  /** Entrance delay in ms, to stagger cards. */
  delay?: number
  sx?: SxProps<Theme>
  children?: ReactNode
}

/** White card: 12px radius, hairline border, soft fade-in. */
export const Card: FC<CardProps> = ({ title, subtitle, actions, flush, delay = 0, sx, children }) => (
  <Box
    sx={{
      ...cardSurfaceSx,
      animation: `${fadeSlideIn} 0.4s ease-out ${delay}ms both`,
      minWidth: 0,
      // clip (not hidden) keeps the rounded corners without becoming a scroll container.
      overflow: 'clip',
      ...sx,
    }}
  >
    {(title || actions) && (
      <Stack
        direction="row"
        alignItems={actions && !subtitle ? 'center' : 'flex-start'}
        justifyContent="space-between"
        spacing={2}
        sx={{ px: 2.5, pt: 2.25, pb: flush ? 2 : 0 }}
      >
        <Box sx={{ minWidth: 0 }}>
          {title && <Typography component="h2" sx={{ fontSize: 14, fontWeight: 600, color: themeColor.slate }}>{title}</Typography>}
          {subtitle && <Typography sx={{ fontSize: 12.5, color: themeColor.slate50, mt: 0.25 }}>{subtitle}</Typography>}
        </Box>
        {actions}
      </Stack>
    )}
    {flush ? children : <Box sx={{ p: 2.5, pt: title ? 2 : 2.5 }}>{children}</Box>}
  </Box>
)
